export const FormQuestionTypes = {
  singleChoice: 'singleChoice',
  multiChoice: 'multiChoice',
  singleChoiceTable: 'singleChoiceTable',
  ranking: 'ranking',
  freeText: 'freeText',
  iconRating: 'iconRating',
  locationChoice: 'locationChoice',
  locationsProposal: 'locationsProposal',
  filesUpload: 'filesUpload',
};



// WEBPACK FOOTER //
// ./src/models/survey/FormQuestionTypes.js